import {DefaultTheme as theme} from "../../../../../theme";
import {RoundedButton} from "../../../../../elements";
import {observer} from "mobx-react";
import {usePromptManagementStore} from "../../hooks";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ErrorSeverityEnum} from "../../types";
import {ActionsHeaderWrapper} from "./ActionsHeader.styled";

export const ActionsHeaderCreate = observer(() => {
  const store = usePromptManagementStore();
  const { error } = store;
  const navigate = useNavigate();
  
  const onHandleCreatePrompt = useCallback(async () => {
    await store.create();
    if (error.show && error.severity === ErrorSeverityEnum.SUCCESS) {
      navigate("/v2/prompt-management-system");
    }
  }, []);

  const onHandleCancelPrompt = useCallback(() => {
    store.cancel();
    navigate("/v2/prompt-management-system");
  }, []);
  
  return (
    <ActionsHeaderWrapper>
      <RoundedButton
        width="99px"
        height="40px"
        color={theme.colors.davysGrey}
        kind="secondary"
        outline={true}
        onClick={onHandleCancelPrompt}
      >
        Cancel
      </RoundedButton>
      <RoundedButton
        width="99px"
        height="40px"
        color={theme.colors.activeBlue}
        onClick={onHandleCreatePrompt}
      >
        Create
      </RoundedButton>
    </ActionsHeaderWrapper>
  );
});
